import { React, Component } from 'utils';
import { withRouter } from 'react-router-dom';

function PageListener(props) {
	ga('set', 'page', props.location.pathname);
	ga('send', 'pageview');
	return null;
}

export default withRouter(PageListener);


// WEBPACK FOOTER //
// ./src/modules/components/pagelistener.js